exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-container {\n  position: relative;\n}\n.dropdown-item.full-width {\n  padding: 0 0.55rem 0.45rem 0.55rem;\n}\n.dropdown-item.full-width:active {\n  background-color: transparent;\n  color: #212529;\n}\n", ""]);

// exports
